import React, { useState } from 'react';
import { COLORS, IMAGES } from '@app/constants';
import { useToken } from '@app/hooks';
import { useMyProfile } from '../../../../hooks/user/myprofile';
import CIUtils from '../../../../../utils/ciutils';
import { HeaderProfieSection, HeaderProfieUid } from '../styles';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import { VITE_APP_API_MEDIA_URL } from '@/app/constants/APIKEYS';
import * as MenuIcons from '@app/components/QBIT/Header/components/MenuIcons';

const selectMenuList = [
  {
    title: 'assets',
    link: '/asset',
    icon: <MenuIcons.AssetsIcon size={20} />,
  },
  {
    title: 'accountSecurity',
    link: '/settings?tab=1',
    icon: <MenuIcons.SecurityIcon size={20} />,
  },
  {
    title: 'referralProgram',
    link: '/referral',
    icon: <MenuIcons.ReferralIcon size={20} />,
  },
  {
    title: 'audit',
    link: '/settings?tab=2',
    icon: <MenuIcons.KycAuditIcon size={20} />,
  },
  {
    title: 'competitionHistory',
    link: '/settings?tab=4',
    icon: <MenuIcons.TradingCompetitionIcon size={20} />,
  },
  {
    title: 'settings',
    link: '/settings?tab=5',
    icon: <MenuIcons.SettingsIcon size={20} />,
  },
];

const HeaderProfie = () => {
  const { mutate: mutateToken } = useToken();
  const { data: myinfo, mutate: mutateProfile } = useMyProfile();

  const navigate = useNavigate();

  return (
    <HeaderProfieSection>
      <ProfileRow>
        <UserImage
          src={
            myinfo?.profileimage
              ? `${VITE_APP_API_MEDIA_URL}/${myinfo?.profileimage}`
              : IMAGES.avatar
          }
        />

        <HeaderProfieUid>
          <UserName>{myinfo?.nickname}</UserName>

          <UserUID>UID : {CIUtils.padId(myinfo?.id)}</UserUID>
        </HeaderProfieUid>
      </ProfileRow>

      <SelectWrap>
        {selectMenuList.map((item) => (
          <SelectText key={item.title} onClick={() => navigate(item.link)}>
            <div>{item.icon}</div>
            <span>{t(item.title)}</span>
          </SelectText>
        ))}
      </SelectWrap>

      {/*<AuthButtonLists title={"accountSecurity"} go={"/settings?tab=1"} />*/}

      {/*<AuthButtonLists title={"referralProgram"} go={"/referral"} />*/}

      {/*<AuthButtonLists title={"audit"} go={"/settings?tab=2"} />*/}

      {/* <AuthButtonLists
				title={'tradingViewAlerts'}
				go={'/settings?tab=4'}
			/> */}
      {/*<AuthButtonLists title={"settings"} go={"/settings?tab=3"} />*/}

      {/* <AuthButtonLists title={'myFeeRates'} go={'settings'} />
			<AuthButtonLists title={'myRewards'} go={'settings'} /> */}
      {/* <AuthButtonLists title={'subaccount'} go={'settings'} /> */}
      {/* <AuthButtonLists title={'api'} go={'/settings'} /> */}

      {/*<AuthButtonLists*/}
      {/*  title={"logout"}*/}
      {/*  action={() => {*/}
      {/*    mutate(null);*/}
      {/*    // setTimeout(() => window.location.reload(), 100)*/}
      {/*  }}*/}
      {/*  style={{*/}
      {/*    width: "50%",*/}
      {/*    marginTop: 15,*/}
      {/*    marginLeft: 130,*/}
      {/*    alignItems: "flex-end",*/}
      {/*  }}*/}
      {/*/>*/}
      <LogoutText onClick={() => navigate('/logout')}>{t('logout')}</LogoutText>
    </HeaderProfieSection>
  );
};

export default React.memo(HeaderProfie);

const ProfileRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 19px 16px;

  border-bottom: 1px solid ${({ theme }) => theme.COLORS.PrimaryBorder};
`;

const UserImage = styled.img`
  width: 42px;
  height: 42px;
  margin-right: 10px;
  border-radius: 100%;
`;

const UserName = styled.div`
  font-weight: 600;
  font-size: 15px;
  line-height: 18px;
  color: ${({ theme }) => theme.text};
`;

const UserUID = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: ${({ theme }) => theme.text};
`;

const SelectText = styled.div`
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 16.71px;
  color: ${({ theme }) => theme.text};
  padding: 10px 0;

  display: flex;
  align-items: center;
  gap: 10px;

  &:hover {
    color: #007aff;
  }
`;

const SelectWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: 20px;
`;

const LogoutText = styled.div`
  text-align: end;
  padding: 10px 20px 20px 20px;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 16.71px;
  color: ${({ theme }) => theme.inputPlaceholderText};

  &:hover {
    color: #007aff;
  }
`;
